import httpClient from "@hd/http-client/http-client";
import { useMutation } from "@tanstack/react-query";

const request = async (communicationIds: string[]) => {
  const result = await httpClient.delete<boolean>(
    import.meta.env.VITE_HD_API_URL + `/communication/scheduled/delete`,
    {
      data: communicationIds,
    },
  );
  return result.data;
};

export const useDeleteScheduledCommunicationMutation = () => {
  return useMutation({
    mutationFn: (communicationIds: string[]) => request(communicationIds),
  });
};
